import { clearAuthAndRedirect, shouldHandleAuthRedirect } from '../services/http/auth.js';

/**
 * Interceptor global para fetch que maneja automÃ¡ticamente errores 401 y 403.
 * Se mantiene para retrocompatibilidad mientras se migran las features al httpClient.
 */

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;
  const skipGlobalAuthRedirect = Boolean(args[1]?.__skipGlobalAuthRedirect);

  if (
    !skipGlobalAuthRedirect
    && (response.status === 401 || response.status === 403)
    && shouldHandleAuthRedirect(requestUrl)
  ) {
    clearAuthAndRedirect();
  }

  return response;
};

export default window.fetch;
